import {useEffect} from 'react';
import logger from '../logger';

const IframeLoginHandler = () => {
    useEffect(() => {
        const handleMessage = (event) => {
            // Uncomment this origin check for production
            if (event.origin !== 'https://app.treeads-project.eu') {
                return;
            };
            
            logger.log('Raw message received:', event.data);
            const data = event.data;

            // Check if the data contains the token property
            if (typeof data === 'string' && data.includes('Bearer')) {
                const token = data.split(' ')[1]; // Split the string and get the token after "Bearer"
                localStorage.setItem('access', token); // Store the token in localStorage
                logger.log('Token received and stored:', token);
            } else if (data && data.token) {
                const token = data.token; // If it's in object format, retrieve it directly
                localStorage.setItem('access', token);
                logger.log('Token received and stored:', token);
            } else {
                logger.log('Invalid message received, does not contain token');
            }
        };

        // Add event listener for message events
        window.addEventListener('message', handleMessage);

        if (window !== window.parent) {
            window.parent.postMessage("render-completed", "https://app.treeads-project.eu/treeads/dashboard");  // Use '*' or a specific origin
            logger.log('Render completion message sent to parent');
        } else {
            logger.log('No parent window detected');
            return;  // Early return if there's no parent window
        }

        // Clean up the event listener on unmount
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    return null;
};

export default IframeLoginHandler;